import React, { useState, useEffect } from "react";
import { Form, InputNumber } from "antd";
import { elvis } from "../../Utils";

const VehicleDamageForm = props => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                quantity: props.record.damage.quantity,
            });
        }
    }, [props.record.damage, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        const newDamage = { ...props.record };
        newDamage.damage.quantity = elvis(allValues.quantity);
        newDamage.damage.damageClass = props.damageClass;
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newDamage.valid = true;
                props.parentCallback(newDamage);
            })
            .catch(() => {
                newDamage.valid = false;
                props.parentCallback(newDamage);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="vehicleDamageForm"
        >
            <Form.Item label="N. of damaged" name="quantity">
                <InputNumber />
            </Form.Item>
        </Form>
    );
};

export default VehicleDamageForm;